__turbopack_context__.v({
  "badge": "unpublishedCourseBadge-module__x5c7gG__badge",
  "icon": "unpublishedCourseBadge-module__x5c7gG__icon",
});
